import {useAppSelector} from '../../../hooks/redux'
import {PathElem, PathLink} from './mainLayout.style'

import {RightArrow} from '../../../assets/icons/rightArrow'
import {MAX_URL_LENGTH} from '../../../pages/subjects/SubjectEdit'
import {useLocation} from 'react-router-dom'


const Breadcrumbs = (props: any) => {
    const pp = useAppSelector((state) => state.data)
    let {subjects} = pp
    const {currentItem} = useAppSelector((state) => state)
    const {pathname} = useLocation()

    let urls: string[] = pathname.split('/').filter((it) => it)

    let names: any = {
        interpretations: 'Diseases',
        diseases: 'Diseases',
        recommendations: 'Recommendations',
        indicators: 'Biomarkers',
        'biomarkers': 'Biomarkers',
    }

    function getUrl(limit: number) {
        let url = ''
        let ind = -1
        while (++ind < limit) {
            url += '/' + urls[ind]
        }
        return url
    }

    let name = names[urls[1]] || '-'
    let currentData = currentItem.data || {}

    let url1 = getUrl(1);
    let selectedSubject = subjects[urls[0]]

    console.log("qqqqq vurl1url1url1", url1);
    let arr = /create\-theme/gi.test(url1) ? [{
        name: 'Enter Theme Name',
    }] : [
        {
            url: url1 + '/biomarkers',
            name: (selectedSubject || {}).name || 'Enter Theme Name',
        },
        {url: urls.length > 2 ? getUrl(2) : '', name},
        {
            ...(urls.length > 2 && {
                url: null,
                name: currentData._id
                    ? currentData.name || 'Enter name'
                    : 'Create New ' + name.replace(/s$/gi, ''),
            }),
        },
    ]

    if (!selectedSubject && arr.length > 1) {
        return null
    }

    function getNameText(value: any) {
        if (typeof value === 'string') {
            return value
        }
        if (value && typeof value === 'object') {
            return value.en || ''
        }
        return ''
    }

    // console.log("RENDER DEUBG: qqqqq arr", arr, subjects);
    return (
        <>
            {(arr || []).map((it, ind) => {
                const key = `${it.name || 'item'}_${ind}`
                const nameText = getNameText(it.name)
                const shortName = nameText.slice(0, MAX_URL_LENGTH)
                const hasOverflow = nameText.slice(MAX_URL_LENGTH).length > 0
                return it.url ? (
                    <><PathLink to={it.url} key={key} data-ellipse>
                        {shortName}
                        {hasOverflow && '...'}
                    </PathLink>
                        <RightArrow data-arrow-right/></>
                ) : (
                    <PathElem key={key} data-ellipse>
                        {shortName}
                        {hasOverflow && '...'}
                    </PathElem>
                )
            })}
        </>
    )
}

export default Breadcrumbs
